module.exports = __webpack_public_path__ + "img/img01.660e922b.jpg";